import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { backendApi } from "../../api/apiService";
import LoaderImage from "../../images/spinner.gif";
import noData from "../../images/noData.png";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdViewTimeline } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaEdit,
  FaMobile,
  FaSearchLocation,
  FaIdCardAlt,
  FaUserTie,
  FaUserCheck,
} from "react-icons/fa";
import { RiUserSearchFill } from "react-icons/ri";
import { BsJoystick } from "react-icons/bs";
// import ShortListPopup from "./shortListPopup";
import { FcHighPriority } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import ReScheduleInterviewPopup from "../schedule/reScheduleInterviewPopup.jsx";
import { error } from "jquery";
import { useSelector } from "../../components/hooks/hooks.js";

function Schedules() {
  const roleId = parseInt(window.localStorage.getItem("role_id"));
  const isAdminRole = roleId === 1 || roleId === 2 || roleId === 5;
  const { userDetails, userData } = useSelector((state) => state.login);
  // console.log("🚀 ~ userDetails:", userData);

  const [interviews, setInterviews] = useState([]);
  const [showShortList, setShowShortList] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const navigate = useNavigate();
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [fromdaysDate, setFromDate] = useState();
  const [todaysDate, setTodaysDate] = useState();
  const [searchCandidateName, setSearchCandidateName] = useState("");
  const [opening, setOpening] = useState({});
  const [loading, setLoading] = useState(false);
  const [Isloading, setIsLoading] = useState(true);

  useEffect(() => {
    viewschedules();
  }, []);

  const Cancel = () => {
    setShowShortList(false);
  };

  const viewschedules = () => {
    setLoading(true);
    setIsLoading(true);
    var req = {
      functionName: "SchedulesListing",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
    };

    backendApi(req).then((response) => {
      if (response.success == "1") {
        setInterviews(
          response.interviews.filter((o) => {
            return new Date(o.end_date).getTime() >= new Date().getTime();
          })
        );
      } else {
        setInterviews([]);
      }
      setLoading(false);
      setIsLoading(false);
    });
  };

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const goToEditPage = (candidateId) => {
    navigate(`/candidateprofile/${candidateId}`, {
      state: { from: 'schedulepage' }
    });
  };
  const goToEvaluationPage = (candidateId) => {
    navigate(`/candidate/candidateEvaluation`, {
      state: {
        candidateId,
        from: 'oldshedules'
      },
    });
  };

  const candidateInterview = (id, data) => {
    setCandidateId(id);
    setScheduleInterview(true);
    setOpening(data);
  };

  const closePopup = () => {
    viewschedules();
    setScheduleInterview(false);
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);
    // if (expiryDate < date)
    //     handleExpiryDateChange(date)
  };
  const handleToDateChange = (date) => {
    setTodaysDate(date);
    // if (expiryDate < date)
    //     handleExpiryDateChange(date)
  };
  function formatDateFromString(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, hence the +1
    const day = date.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  const searchThroughCandidate = () => {
    const formattedFirstDay = fromdaysDate
      ? formatDateFromString(fromdaysDate)
      : "";
    const formattedLastDay = todaysDate ? formatDateFromString(todaysDate) : "";
    if (!formattedFirstDay && formattedLastDay) {
      alert("Choose Both Dates or Leave Them Empty");
      return false;
    } else if (formattedFirstDay && !formattedLastDay) {
      alert("Choose Both Dates or Leave Them Empty");
      return false;
    }

    if (
      formattedFirstDay &&
      formattedLastDay &&
      formattedFirstDay > formattedLastDay
    ) {
      alert("To Date must be greater than or equal to From Date");
      return false;
    }
    setLoading(true);
    const data = {
      functionName: "SchedulesListing",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
      candidate_name: searchCandidateName,
      start_date: formattedFirstDay,
      end_date: formattedLastDay,
    };

    backendApi(data)
      .then((response) => {
        if (response.success === "1") {
          setInterviews(
            response.interviews.filter((o) => {
              return new Date(o.end_date).getTime() >= new Date().getTime();
            })
          );
        } else {
          setInterviews([]);
        }
      })
      .catch((error) => {
        setInterviews([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  return (
    <>
      {/* <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Interview Schedules"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          /> */}

      <div class="card-header mt-3 bg-transparent border-0">
        {loading && (
          <div className="loader-div" key={loading}>
            <img src={LoaderImage} alt="Loader" className="loader" />
          </div>
        )}
        <div className="row">
          <div className="col-md-4 mb-md-0 mb-2">
            <input
              className="form-control mr-1"
              type="text"
              id="CurrentPassword"
              placeholder="Candidate Name"
              onChange={(e) => setSearchCandidateName(e.target.value)}
              value={searchCandidateName}
              tabIndex="0"
            />
          </div>
          <div className="col-md-3 mb-md-0 mb-2">
            <DatePicker
              selected={fromdaysDate}
              className="form-control"
              dateFormat="dd/MM/yyyy"
              onChange={(date) => handleFromDateChange(date)}
              showYearDropdown
              showMonthDropdown
              minDate={new Date()}
              placeholderText="Select date "
            // minDate={new Date()}
            />
          </div>
          <div className="col-md-3 mb-md-0 mb-2">
            <DatePicker
              selected={todaysDate}
              className="form-control"
              dateFormat="dd/MM/yyyy"
              onChange={(date) => handleToDateChange(date)}
              showYearDropdown
              minDate={new Date()}
              showMonthDropdown
              placeholderText="Select date "
            // minDate={new Date()}
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-search-custome"
              // OnClick={searchThroughCandidate()}
              onClick={() => searchThroughCandidate()}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        {Isloading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading Interviews...</p>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: "3%", minWidth: "30px" }}>#</th>
                <th style={{ width: "28%", minWidth: "230px" }}>
                  Candidate Details
                </th>
                <th style={{ width: "28%", minWidth: "230px" }}>
                  Job Opening Details
                </th>
                <th style={{ width: "28%", minWidth: "230px" }}>
                  Interview Details
                </th>
                <th style={{ width: "13%", minWidth: "140px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {interviews?.length > 0 ? (
                interviews?.map((interview, index) => {
                  console.log("Interview Data:", interview);
                  if (
                    interview.Interviewer.some(obj => obj.sec_user_id === userData[0].id) ||
                    interview.created_by == userData[0].id
                  ) {
                    return (
                      <tr>
                        <td aria-label="Lead Summary">
                          {" "}
                          <span className="schedule-td-head">{index + 1}</span>
                        </td>
                        <td aria-label="Lead Summary">
                          <span className="schedule-td-head">
                            {interview.candidate[0]?.full_name}
                          </span>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaAddressBook title="Address" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {" "}
                              {interview.candidate[0]?.address
                                ? interview.candidate[0]?.address
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              {" "}
                              <FaEnvelope title="Email" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.candidate[0]?.email_id
                                ? interview.candidate[0]?.email_id
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaMobile title="Contact No:" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.candidate[0]?.mobile_no
                                ? interview.candidate[0]?.mobile_no
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaAward title="Experience" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.candidate[0]?.total_experiance
                                ? interview.candidate[0]?.total_experiance
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaClock title="Uploaded On" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {formatDateToCustomFormat(
                                interview.candidate[0]?.created_on
                              )}
                            </span>
                          </div>
                        </td>
                        <td aria-label="Job Details">
                          <span className="schedule-td-head">
                            {interview.job_opening[0]?.summary}
                          </span>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaIdCardAlt title="Job Type" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.job_opening[0].job_type
                                ? interview.job_opening[0].job_type
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <RiUserSearchFill
                                title="Open Positions"
                                size={12}
                              />
                            </span>
                            <span class="font-Medium ">
                              {interview.job_opening[0].no_of_position
                                ? interview.job_opening[0].no_of_position
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaUserCheck title="Filled Positions" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.job_opening[0].filled_position
                                ? interview.job_opening[0].filled_position
                                : 0}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FcHighPriority title="Priority" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.job_opening[0].priority
                                ? interview.job_opening[0].priority
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaClock title="Duration Of Vacancy" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {formatDateToCustomFormat(
                                interview.job_opening[0]?.start_date
                              )}{" "}
                              -{" "}
                              {formatDateToCustomFormat(
                                interview.job_opening[0]?.end_date
                              )}
                            </span>
                          </div>
                        </td>
                        <td aria-label="Interview Details">
                          <span className="schedule-td-head">
                            {interview?.interview_type}
                          </span>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaUserTie title="Interviewer" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview?.Interviewer &&
                                interview?.Interviewer.map((loc, i) => (
                                  <span
                                    key={i}
                                    style={{
                                      fontSize: 10.5,
                                      backgroundImage:
                                        "linear-gradient(310deg, #2dce89, #2dcecc)",
                                      borderRadius: "5px",
                                      padding: "3px 10px",
                                      color: "#fff",
                                      display: "inline-block",
                                    }}
                                  >
                                    {loc.Interviewer_name}
                                  </span>
                                ))}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <BsJoystick title="Status" size={12} />
                            </span>
                            <span class="font-Medium ">{interview?.status}</span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaClock title="Interview Time" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview?.start_date} - {interview?.end_date}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <MdViewTimeline title="Notice Period" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.candidate[0]?.notice_period
                                ? interview.candidate[0]?.notice_period
                                : "NA"}
                            </span>
                          </div>
                          <div class="mb-2 d-flex">
                            <span class="label-text me-1">
                              <FaLocationDot title="Job Location" size={12} />
                            </span>
                            <span class="font-Medium ">
                              {interview.location ? interview.location : "NA"}
                            </span>
                          </div>
                        </td>
                        <td aria-label="View">
                          <div className="d-flex align-items-center flex-wrap gap-2">
                            <button
                              className="btn-btn btn btn-btn2"
                              onClick={() => goToEditPage(interview.candidate_id)}
                            >
                              View Candidate
                            </button>
                            <button
                              className="btn-btn btn btn-btn2"
                              onClick={() =>
                                goToEvaluationPage(interview.candidate_id)
                              }
                            >
                              Evaluation
                            </button>
                            <button
                              className=" btn-btn btn btn-btn1"
                              onClick={() =>
                                candidateInterview(
                                  interview.candidate_id,
                                  interview
                                )
                              }
                            >
                              Re-Schedule
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  } else {
                    console.log("No match for interview:", interview);
                  }
                })
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No Scheduled Interviews
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>


      {/* </div> */}
      {scheduleInterview && (
        <ReScheduleInterviewPopup
          onClose={closePopup}
          candidateId={candidateId}
          opening={opening}
        />
      )}
      {/* </div> */}
    </>
  );
}

export default Schedules;
